import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=2ecc722a&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=2ecc722a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc722a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecc722a')) {
      api.createRecord('2ecc722a', component.options)
    } else {
      api.reload('2ecc722a', component.options)
    }
    module.hot.accept("./Player.vue?vue&type=template&id=2ecc722a&scoped=true&", function () {
      api.rerender('2ecc722a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/SPFPlayer/lib/Player.vue"
export default component.exports